import FirstTimeLoginPage from "components/pages/FirstTimeLoginPage";

/**
 * @name CaptureFirstLoginRememberDevice
 * @returns {React.Component}
 * @description Capture component for the first time login page
 */
export default function CaptureFirstLoginRememberDevice(props) {
    return <FirstTimeLoginPage />
}